import helper from '@/libs/forms';
import schemaHelper from '@/components/profile/sections/tabs/financial/resources/schemaHelper';


export default {
  fields: schemaHelper.generalFields().concat([
    helper.currency('Monthly Payment', 'monthlyPayment', true),
  ]),
};



// WEBPACK FOOTER //
// ./src/components/profile/sections/tabs/financial/liabilities/schemas/otherInstallments.js